import axios from "@/plugins/axios";

let url = (data) => "/api/console/shop/exhibitions/${_exhibition}/files".interpolate(data);

export default {
    gets(data) {
        return axios.get(url(data), data).then((result) => result.data);
    },
    get(data) {
        return axios.get(`${url(data)}/${data._id}`).then((result) => result.data);
    },
    post({ _exhibition, index }, file) {
        var headers = { "Content-Type": "multipart/form-data" };
        var formData = new FormData();
        formData.append("index", index);
        formData.append("file", file);
        return axios.post(`${url({ _exhibition })}`, formData, { headers }).then((result) => result.data);
    },
    put(data) {
        return axios.put(`${url(data)}/${data._id}`, data).then((result) => result.data);
    },
    delete(data) {
        return axios.delete(`${url(data)}/${data._id}`).then((result) => result.data);
    },
};
